import { CompareIcon, Flex, Image, Typography } from '@iheartjane/reefer';

import compareSkeleton from './compare-skeleton.svg';
import styles from './compareHint.module.css';

export const CompareHint = () => (
  <Flex
    flexDirection="row"
    alignItems="center"
    gap={12}
    justifyContent="center"
  >
    <Image
      className={styles['image']}
      src={compareSkeleton}
      altText="Sample product card with compare icon"
      height="106px"
      width="auto"
    />
    <Flex flexDirection="column">
      <Typography variant="body-bold" as="div">
        Tap the
        <div className={styles['inlineIcon']}>
          <CompareIcon size="sm" color="primary" />
        </div>
        on any
      </Typography>
      <Typography variant="body-bold" as="p">
        product card to compare
      </Typography>
    </Flex>
  </Flex>
);
